import axios from 'axios';

export const ReportsPageApi = {
  loadEmailList: filter =>
    axios.get(`/api/public/reports/email?filter=${filter}`),
  deleteEmail: data => axios.delete(`/api/public/reports/email/${data.email}`),
  addEmail: ( email) =>
    axios.post(`/api/public/reports/email?email=${email}`),
  loadReportFincenterActs: (filter) =>
    axios.get(`/api/public/info/fincenter/acts?filter=${JSON.stringify(filter)}`),
  exportFincenterAct: (documentId) =>
    axios.get(`api:fileStore/public/directory/1/document/${documentId}/file?documentVersion=1&action=download`, {
      responseType: 'blob',
    }),
  viewFincenterAct: (documentId) =>
    axios.get(`api:fileStore/public/directory/1/document/${documentId}/file?documentVersion=1&action=view`, {
      responseType: 'blob'
    }),
  loadFincenterActById: id =>
    axios.get(`/api/public/info/fincenter/act/${id}`),
  generateFincenterAct: serviceProviderId =>
    axios.post(`/api/public/fincenter/act/generate/${serviceProviderId}`),
  getFincenterActSignString: id =>
    axios.post(`api/public/info/fincenter/acts/sign_string`, { id }),
  signFincenterAct: (actId, signaturesDo) =>
    axios.post(`/api/public/info/fincenter/acts/${actId}/sign`, { signaturesDo }),
  signFincenterActOo: (actId, signaturesOo) =>
    axios.post(`/api/public/info/fincenter/acts/${actId}/sign`, { signaturesOo }),
  loadAllFincenterActs: filter =>
    axios.get(`/api/public/info/fincenter/acts?filter=${JSON.stringify(filter)}`),
};